import { Component } from '@angular/core';

@Component({
  selector: 'qa-auth-flow-wrapper',
  templateUrl: './auth-flow-wrapper.component.html',
  styleUrls: ['./auth-flow-wrapper.component.scss'],
})
export class AuthFlowWrapperComponent {}
